// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import type { AttentionReason } from '@/constants/attention';
import { pluralize } from '@/utilities/pluralize';

/**
 * Phrasing for each reason, used in the time-in-status tooltip. `wholeDays` is
 * the floored day count the shipment has been in its current state.
 */
const SHIPMENT_CYCLE_TIME_ATTENTION_REASON_PHRASE: Record<
  AttentionReason,
  (wholeDays: number) => string
> = {
  open_not_shipped: (wholeDays) =>
    `Created over ${pluralize(wholeDays, { singular: 'day' })} ago, not yet shipped`,
  shipped_not_delivered: (wholeDays) =>
    `Shipped over ${pluralize(wholeDays, { singular: 'day' })} ago, not yet delivered`,
  delivered_not_received: (wholeDays) =>
    `Delivered over ${pluralize(wholeDays, { singular: 'day' })} ago, not yet received`,
};

/**
 * Builds the badge tooltip from the tripped reason and the floored day count.
 */
export function getShipmentCycleTimeAttentionTooltip(
  reason: AttentionReason,
  wholeDays: number
): string {
  return SHIPMENT_CYCLE_TIME_ATTENTION_REASON_PHRASE[reason](wholeDays);
}
